import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useAttendanceFormSessionDetails } from "./hooks";

const withAttendanceFormSessionDetails =
  ({ allowRender = false }: { allowRender?: boolean } = {}) =>
  (Component: React.ComponentType<any>) => {
    // eslint-disable-next-line react/display-name
    return (props: any) => {
      const location = useLocation();
      const { eventId } = useParams<{ eventId?: string }>();
      const searchParams = new URLSearchParams(location.search);
      const eventHash = searchParams.get("sig");
      const { fetchAttendanceFormSessionDetails, loading, fetched } =
        useAttendanceFormSessionDetails(eventId, eventHash);

      React.useEffect(() => {
        let isMounted = true;
        if (!loading && !fetched && isMounted) {
          fetchAttendanceFormSessionDetails();
        }
        return () => {
          isMounted = false;
        };
      }, [fetched, loading, fetchAttendanceFormSessionDetails]);
      if (!allowRender && (loading || !fetched)) return <div />;

      return <Component {...props} />;
    };
  };

export { withAttendanceFormSessionDetails };
